// extracted by mini-css-extract-plugin
export default {"carrinho":"Cart_carrinho__MVgb0","total":"Cart_total__nuQZ-","finalizar":"Cart_finalizar__RZy+V"};